import React, { ReactElement } from "react";
import Head from "next/head";
import Sudoku from "@/components/sudoku/Sudoku";
import Steps from "@/components/koach/Steps";
import Knowledge from "@/components/koach/Knowledge";
import Faqs from "@/components/koach/Faqs";
import Download from "@/components/koach/DownloadBanner";

import { MainLayout } from "@/containers/layout/KoachLayout";

const Klink = (): JSX.Element => {
  return (
    <>
      <Head>
        <title>
          Sudoku #1 | Provided by Klink, The Super App for Future Home Owners
        </title>
        <link rel="canonical" href="https://www.klink-app.com" />
        <meta
          name="description"
          content="Solving Sudoku can be tough, but with the right strategies and tools from the Klink App, you can tackle home buying with ease. Let Klink help you find ways to get the home you want!"
        />

        <meta
          name="keywords"
          content="Klink, financial goals, smart spending, save money, financial milestones, savings missions"
        />
        <meta name="language" content="English" />
        <meta name="author" content="Klink App" />

        <meta
          name="twitter:card"
          content="Solving Sudoku can be tough, but with the right strategies and tools from the Klink App, you can tackle home buying with ease. Let Klink help you find ways to get the home you want!"
          key="twcard"
        />
        <meta name="twitter:url" content="https://www.klink-app.com/" />
        <meta
          name="twitter:title"
          content="Sudoku #1 | Provided by Klink, The Super App for Future Home Owners"
        />
        <meta name="twitter:image" content="/meta-opengraph-landing.png" />

        <meta name="twitter:creator" content="klink_app" key="twhandle" />

        <meta
          property="og:url"
          content="https://www.klink-app.com/sudoku/1"
          key="ogurl"
        />
        <meta
          property="og:image"
          content="/meta-opengraph-landing.png"
          key="ogimage"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="Klink" key="ogsitename" />
        <meta
          property="og:title"
          content="Sudoku #1 | Provided by Klink, The Super App for Future Home Owners"
          key="ogtitle"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_GB" />
        <meta
          property="og:description"
          content="Solving Sudoku can be tough, but with the right strategies and tools from the Klink App, you can tackle home buying with ease. Let Klink help you find ways to get the home you want!"
          key="ogdesc"
        />
      </Head>
      <div className="bg-white">
        <Sudoku />
        <Steps />
        <Knowledge />
        <Faqs />
        <Download />
      </div>
    </>
  );
};

Klink.getLayout = function getLayout(page: ReactElement) {
  return (
    <>
      <MainLayout theme="dark">{page}</MainLayout>
    </>
  );
};

export default Klink;
